import { Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { useParams } from "react-router-dom";

import { useContractsQuery } from "AdvisoryManagement/Api/Queries/useContractsQuery";
import { ContractsTableRow } from "AdvisoryManagement/Components/Client/Contracts/ContractsTableRow";
import { ContractStatus } from "Infrastructure/Api/Api";

export const ContractsTable = () => {
	const { advisoryCaseId } = useParams<{ advisoryCaseId: string }>();

	const { data: contracts } = useContractsQuery(advisoryCaseId, [
		ContractStatus.InProgress,
	]);

	if (!contracts?.items || contracts.items.length === 0) {
		return (
			<Typography color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
				Žádné rozpracované smlouvy
			</Typography>
		);
	}

	return (
		<TableContainer
			sx={{
				p: 0,
				overflowX: "auto",
				maxWidth: "100%",
				backgroundColor: "#FFFFFF",
				borderRadius: 2,
			}}
		>
			<Table sx={{ width: "100%" }}>
				<colgroup>
					<col style={{ width: "50px" }} />
					<col />
					<col style={{ width: "350px" }} />
					<col style={{ width: "130px" }} />
					<col style={{ width: "66px" }} />
				</colgroup>
				<TableBody
					sx={{
						"& .MuiTableCell-body": {
							py: 1.5,
							borderBottom: "1px solid #E9EAEB",
							verticalAlign: "middle",
						},
						"& .MuiTableRow-root:hover": {
							backgroundColor: "#FAFAFA",
						},
					}}
				>
					{contracts.items.map((contract) => (
						<ContractsTableRow key={contract.contractId} contract={contract} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
